import * as z from 'zod';

export const reportTemplatePeriodFormSchema = z.object({
  start_datetime: z.date(),
  end_datetime: z.date(),
});

export type reportTemplatePeriodValues = z.infer<
  typeof reportTemplatePeriodFormSchema
>;

export function createReportTemplatePeriodFormSchema(
  startThreshold?: Date | null,
  endThreshold?: Date | null,
  startThresholdText?: string | null,
  endThresholdText?: string | null,
  existingSchema?: any,
) {
  let schema = existingSchema ? existingSchema : reportTemplatePeriodFormSchema;

  // Add cross-field validation - show errors on both fields
  schema = schema
    .refine((data: any) => data.end_datetime > data.start_datetime, {
      message: 'End date must be after start date',
      path: ['end_datetime'],
    })
    .refine((data: any) => data.end_datetime > data.start_datetime, {
      message: 'Start date must be before end date',
      path: ['start_datetime'],
    });

  // Add threshold validations
  if (startThreshold) {
    schema = schema.refine(
      (data: any) => data.start_datetime >= startThreshold,
      {
        message: `Start date must be within the data range, which is above ${startThresholdText}`,
        path: ['start_datetime'],
      },
    );
  }

  if (endThreshold) {
    schema = schema.refine((data: any) => data.end_datetime <= endThreshold, {
      message: `End date must be within the data time range, which is below ${endThresholdText}`,
      path: ['end_datetime'],
    });
  }

  // Add past date validation
  const now = new Date();
  schema = schema
    .refine((data: any) => data.start_datetime <= now, {
      message: 'Start date cannot be in the future',
      path: ['start_datetime'],
    })
    .refine((data: any) => data.end_datetime <= now, {
      message: 'End date cannot be in the future',
      path: ['end_datetime'],
    });

  return schema;
}
